import { EntityCollectionServiceBase, EntityCollectionServiceElementsFactory } from '@ngrx/data';
import { Injectable } from '@angular/core';
import { GameProviderDailyReport } from '@core/models/game-provider-daily-report.model';

@Injectable()
export class GameProviderDailyReportEntityService extends EntityCollectionServiceBase<GameProviderDailyReport> {
  constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory) {
      super('GameProviderDailyReport', serviceElementsFactory);
  }
}